import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";

const PasswordEyeButton = ({
  showPassword,
  setShowPassword,
}: {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
}) => (
  <button
    className="LoginForm__password-eye"
    type="button"
    aria-label={showPassword ? "Hide password" : "Show password"}
    onClick={() => setShowPassword((v) => !v)}
  >
    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
  </button>
);

export default PasswordEyeButton;
